<template>
    <section class="cursos-hero" :aria-labelledby="titleId">
        <div class="cursos-hero-inner container">
            <div class="cursos-hero-copy">
                <p v-if="eyebrow" class="cursos-hero-eyebrow">
                    <span class="cursos-hero-eyebrow-line" aria-hidden="true"></span>
                    {{ eyebrow }}
                </p>
                <h1 :id="titleId" class="cursos-hero-title">
                    <template v-if="titleParts">
                        {{ titleParts.before }}<span class="cursos-hero-title-accent">{{ titleParts.accent }}</span>{{ titleParts.after }}
                    </template>
                    <template v-else>{{ title }}</template>
                </h1>
                <p v-if="subtitle" class="cursos-hero-subtitle">{{ subtitle }}</p>
                <div class="cursos-hero-search-wrap">
                    <span class="cursos-hero-search-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                    </span>
                    <input
                        :value="modelValue"
                        type="search"
                        class="cursos-hero-search-input"
                        :placeholder="searchPlaceholder"
                        autocomplete="off"
                        :aria-label="searchAriaLabel"
                        @input="$emit('update:modelValue', $event.target.value)"
                    />
                </div>
            </div>

            <div class="cursos-hero-visual" aria-hidden="true">
                <div class="cursos-hero-visual-glow"></div>
                <img :src="watermarkSrc" alt="" class="cursos-hero-watermark" />
                <p class="cursos-hero-script">
                    <span class="cursos-hero-script-accent">{{ scriptParts.accent }}</span><span class="cursos-hero-script-rest">{{ scriptParts.rest }}</span>
                </p>
                <img
                    :src="personSrc"
                    alt=""
                    class="cursos-hero-person"
                    width="432"
                    height="576"
                />
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue';
import personSrc from '@/assets/images/cursos-hero-person.png';
import watermarkSrc from '@/assets/images/logo-mini.png';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        default: '',
    },
    eyebrow: {
        type: String,
        default: '',
    },
    scriptText: {
        type: String,
        default: 'Mais conhecimento, mais resultados!',
    },
    searchPlaceholder: {
        type: String,
        default: 'Buscar cursos...',
    },
    searchAriaLabel: {
        type: String,
        default: 'Buscar cursos',
    },
    modelValue: {
        type: String,
        default: '',
    },
    titleId: {
        type: String,
        default: 'cursos-hero-title',
    },
});

defineEmits(['update:modelValue']);

const TITLE_ACCENT = 'seu ritmo';

const titleParts = computed(() => {
    const lower = props.title.toLowerCase();
    const idx = lower.indexOf(TITLE_ACCENT);
    if (idx === -1) return null;

    return {
        before: props.title.slice(0, idx),
        accent: props.title.slice(idx, idx + TITLE_ACCENT.length),
        after: props.title.slice(idx + TITLE_ACCENT.length),
    };
});

const scriptParts = computed(() => {
    const text = props.scriptText;
    const commaIdx = text.indexOf(',');
    if (commaIdx === -1) {
        return { accent: text, rest: '' };
    }

    return {
        accent: text.slice(0, commaIdx + 1),
        rest: text.slice(commaIdx + 1),
    };
});
</script>
